import { render, staticRenderFns } from "./TaxonomySelector.vue?vue&type=template&id=4927019c&"
import script from "./TaxonomySelector.vue?vue&type=script&lang=js&"
export * from "./TaxonomySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports